export enum SitemapVersionLevelUploadMethod {
    Mbtiles = "Mbtiles",
    Cad = "Cad"
}